import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// import serviceWorker from "../public/serviceWorker";
import { registerServiceWorker } from "./serviceWorkerRegistration";
import { LayoutProvider } from "./context/LayoutContext";
import { UserProvider } from "./context/UserContext";
import reportWebVitals from "./reportWebVitals";
import "react-toastify/dist/ReactToastify.css";
import "react-quill/dist/quill.snow.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <LayoutProvider>
    <UserProvider>
      <App />
    </UserProvider>
  </LayoutProvider>

);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.register();
Notification.requestPermission().then((permission) => {
  if (permission === "granted") {
    registerServiceWorker();
  } else {
    // eslint-disable-next-line no-console
    // console.warn("Push notifications not granted");
  }
});
reportWebVitals();
